import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-pagina-principal',
  templateUrl: './pagina-principal.component.html'
})
export class PaginaPrincipalComponent implements OnInit {
  safeHtml: SafeHtml;
  latitude = 6.8243236;
  longitude = -72.9016794;
  zoom = 6.2;
  seats = [];
  previous;
  proyectos = [];
  energiaGenerada = [];
  dispositivos = [];
  co2evitado = [];
  arbolesPlantados = [];
  energiaConsumida = [];
  done = false;
  con = 0;
  myChart;
  sena = [];
  Style;
  total;
  to1;
  to2;
  to3;
  to4;
  to5;
  to6;
  clientClass;
  totalEG;
  totalCo2;
  totalArboles;
  totalEC;
  co2;
  arboles;
  pesos;
  beneficiarys: any[] = [];
  arrDispac: any[] = [];
  setDiagram: boolean = false;
  dataConversiones: any[] = [];

  dummyContent = [
    { titulo: 'Número de instalaciones', imagen: '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><g><path d="M300,248H276.938l7.013-63.116a8,8,0,0,0-13.93-6.2l-64,72A8,8,0,0,0,212,264h23.062l-7.013,63.116a8,8,0,0,0,13.93,6.2l64-72A8,8,0,0,0,300,248Zm-53.271,55.889,5.222-47A8,8,0,0,0,244,248H229.814l35.457-39.889-5.222,47.005A8,8,0,0,0,268,264h14.186Z"/><path d="M495.77,207.5l-46.09-1.53a198.408,198.408,0,0,0-21.97-52.57L459,119.67a8,8,0,0,0-.21-11.1L402.23,52a8.018,8.018,0,0,0-11.13-.19L357.24,83.49a198.513,198.513,0,0,0-51.7-21.29L304,15.73A8.01,8.01,0,0,0,296,8H216a8,8,0,0,0-7.99,7.7l-1.75,46.55a198.306,198.306,0,0,0-52.12,21.6L119.9,51.81a8.018,8.018,0,0,0-11.13.19L52.21,108.57a8,8,0,0,0-.21,11.1l31.9,34.39a198.324,198.324,0,0,0-21.58,51.9L16.23,207.5a8.01,8.01,0,0,0-7.73,8v80a8,8,0,0,0,7.7,7.99l45.92,1.73a198.319,198.319,0,0,0,21.36,52L51.31,391.6a8.018,8.018,0,0,0,.19,11.13l56.57,56.56a8,8,0,0,0,11.1.21l34.25-31.78a198.18,198.18,0,0,0,52.84,22.03l1.75,46.55A8,8,0,0,0,216,504h80a8.01,8.01,0,0,0,8-7.73l1.54-46.47a198.2,198.2,0,0,0,52.43-21.72l33.86,31.42a8,8,0,0,0,11.1-.21l56.57-56.56a8.018,8.018,0,0,0,.19-11.13l-31.55-33.72a198.258,198.258,0,0,0,21.74-52.66l45.92-1.73a8,8,0,0,0,7.7-7.99v-80A8.01,8.01,0,0,0,495.77,207.5Zm-8.27,80.29-44.3,1.67a7.981,7.981,0,0,0-7.51,6.27,182.531,182.531,0,0,1-24.31,58.86,8,8,0,0,0,.9,9.76l30.44,32.53-45.65,45.65-32.68-30.31a7.986,7.986,0,0,0-9.73-.88,182.386,182.386,0,0,1-58.64,24.28,8.006,8.006,0,0,0-6.26,7.55L288.26,488H223.71l-1.69-44.91a7.983,7.983,0,0,0-6.25-7.51,182.553,182.553,0,0,1-59-24.6,7.987,7.987,0,0,0-9.76.87l-33.08,30.68L68.28,396.88l31.04-33.17a8,8,0,0,0,.92-9.73,182.731,182.731,0,0,1-23.93-58.24,8,8,0,0,0-7.51-6.28L24.5,287.8V223.24l44.44-1.49a8.005,8.005,0,0,0,7.54-6.24,182.355,182.355,0,0,1,24.17-58.14,8.016,8.016,0,0,0-.88-9.74l-30.8-33.2,45.65-45.65L147.67,99.7a7.99,7.99,0,0,0,9.76.91,182.59,182.59,0,0,1,58.34-24.19,7.983,7.983,0,0,0,6.25-7.51L223.71,24h64.55l1.5,44.83a8.006,8.006,0,0,0,6.26,7.55A182.547,182.547,0,0,1,354,100.25a8,8,0,0,0,9.73-.92l32.65-30.55,45.65,45.65-30.2,32.56a8,8,0,0,0-.87,9.76,182.5,182.5,0,0,1,24.56,58.76,8.014,8.014,0,0,0,7.54,6.25l44.44,1.48Z"/><path d="M256,136A120,120,0,1,0,376,256,120.136,120.136,0,0,0,256,136Zm0,224A104,104,0,1,1,360,256,104.118,104.118,0,0,1,256,360Z"/><path d="M256,104c-83.813,0-152,68.187-152,152s68.187,152,152,152,152-68.187,152-152S339.813,104,256,104Zm0,288c-74.99,0-136-61.01-136-136s61.01-136,136-136,136,61.01,136,136S330.99,392,256,392Z"/></g></svg>' },
    { titulo: 'Energía generada', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m256 216a88 88 0 1 0 -88-88 88.1 88.1 0 0 0 88 88zm0-160a72 72 0 1 1 -72 72 72.081 72.081 0 0 1 72-72z"/><path d="m256 32a8 8 0 0 0 8-8v-8a8 8 0 0 0 -16 0v8a8 8 0 0 0 8 8z"/><path d="m248 232v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -16 0z"/><path d="m360 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m144 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m329.539 62.461a7.976 7.976 0 0 0 5.657-2.343l5.657-5.657a8 8 0 1 0 -11.314-11.314l-5.657 5.653a8 8 0 0 0 5.657 13.657z"/><path d="m176.8 195.883-5.657 5.657a8 8 0 0 0 11.314 11.313l5.657-5.658a8 8 0 1 0 -11.314-11.312z"/><path d="m323.882 195.882a8 8 0 0 0 0 11.313l5.657 5.658a8 8 0 1 0 11.314-11.313l-5.657-5.657a8 8 0 0 0 -11.314-.001z"/><path d="m176.8 60.118a8 8 0 1 0 11.318-11.318l-5.657-5.657a8 8 0 0 0 -11.314 11.314z"/><path d="m496 464h-96v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-192v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-96a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-160-48h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm-240 80h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm320-24h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm-208-120h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm344 56h-464v-8h464z"/></g></svg>' },
    { titulo: 'Energía consumida', imagen: '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><g><path d="M40,368a32,32,0,1,0,32,32A32.036,32.036,0,0,0,40,368Zm0,48a16,16,0,1,1,16-16A16.019,16.019,0,0,1,40,416Z"/><path d="M328,400a32,32,0,1,0,32,32A32.036,32.036,0,0,0,328,400Zm0,48a16,16,0,1,1,16-16A16.019,16.019,0,0,1,328,448Z"/><path d="M431.66,80.94A246.366,246.366,0,0,0,256.92,8h-.9C190.72,8,128.96,33.72,82.03,80.49A251.467,251.467,0,0,0,27.9,160.37,247.427,247.427,0,0,0,8,257.86V328a32.172,32.172,0,0,0,31.41,32,31.537,31.537,0,0,0,22.75-9.17A32.984,32.984,0,0,0,72,327.46V312a16,16,0,0,1,16.31-16c8.65.17,15.69,7.59,15.69,16.55V408a32.172,32.172,0,0,0,31.41,32,31.391,31.391,0,0,0,22.75-9.17A32.984,32.984,0,0,0,168,407.46V387.71a31.982,31.982,0,0,0,32,0V472a32.155,32.155,0,0,0,31.4,31.99c.2.01.39.01.59.01a31.5,31.5,0,0,0,22.17-9.16A33.007,33.007,0,0,0,264,471.46V328a16,16,0,0,1,32,0v32a32.155,32.155,0,0,0,31.4,31.99,31.419,31.419,0,0,0,22.76-9.15A33.007,33.007,0,0,0,360,359.46V280a16,16,0,0,1,32,0V392a32.172,32.172,0,0,0,31.41,32,31.423,31.423,0,0,0,22.75-9.17A32.984,32.984,0,0,0,456,391.46v-59.8a31.462,31.462,0,0,0,38.16-4.83A32.984,32.984,0,0,0,504,303.46V256A246.415,246.415,0,0,0,431.66,80.94ZM160,232a8,8,0,0,0-8,8V407.46a16.868,16.868,0,0,1-5.05,11.95A15.6,15.6,0,0,1,135.7,424,16.079,16.079,0,0,1,120,408V312.55c0-17.62-14.08-32.22-31.38-32.54A31.638,31.638,0,0,0,72,284.28V272a8,8,0,0,0-16,0v55.46a16.868,16.868,0,0,1-5.05,11.95A15.551,15.551,0,0,1,39.7,344,16.079,16.079,0,0,1,24,328V257.86a231.553,231.553,0,0,1,18.62-91.22,235.727,235.727,0,0,1,50.7-74.82c2.2-2.2,4.45-4.33,6.72-6.42l29.56,39.4a7.982,7.982,0,0,0,4.83,3.04l36.43,7.29,29.44,51.51,7.48,52.37-13.6,34L168,278.24V240A8,8,0,0,0,160,232Zm184,48v79.46a16.873,16.873,0,0,1-5.05,11.96A15.655,15.655,0,0,1,327.7,376,16.079,16.079,0,0,1,312,360V328a32,32,0,0,0-64,0V471.46a16.873,16.873,0,0,1-5.05,11.96A15.746,15.746,0,0,1,231.7,488,16.079,16.079,0,0,1,216,472V312a8,8,0,0,0-16,0v48a16,16,0,0,1-32,0V294.56l33.57-6.72a8.009,8.009,0,0,0,5.86-4.87l16-40a7.969,7.969,0,0,0,.49-4.1l-8-56a7.983,7.983,0,0,0-.97-2.84l-32-56a7.984,7.984,0,0,0-5.38-3.87l-37-7.41L112.19,74.92A228.28,228.28,0,0,1,256.02,24h.84a234.189,234.189,0,0,1,36.44,2.98L251.29,57.53A8,8,0,0,0,248,64v64a7.986,7.986,0,0,0,2.02,5.31l64,72a8.007,8.007,0,0,0,9.56,1.85l8.84-4.43,10.35,20.7-13.43,20.13a8,8,0,0,0,3.51,11.79l16.44,7.05A31.8,31.8,0,0,0,344,280Zm144,23.46a16.868,16.868,0,0,1-5.05,11.95A15.559,15.559,0,0,1,471.7,320,16.079,16.079,0,0,1,456,304V240a8,8,0,0,0-16,0V391.46a16.868,16.868,0,0,1-5.05,11.95A15.543,15.543,0,0,1,423.7,408,16.079,16.079,0,0,1,408,392V280a31.979,31.979,0,0,0-45.11-29.18l-14.9-6.38,10.67-16a8.024,8.024,0,0,0,.5-8.02l-16-32a8.017,8.017,0,0,0-10.74-3.58l-10.51,5.26L264,124.96V68.07l50.44-36.68A232.245,232.245,0,0,1,488,256Z"/></g></svg>' },
    { titulo: 'Dispositivos de monitoreo instalados', imagen: '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><g><path d="M496,248H416V199.48a64,64,0,1,0-16,0v13.21l-10.34-10.35a8,8,0,0,0-11.32,11.32L400,235.31V248H264V223.6A80.013,80.013,0,0,0,299.31,76.72a48,48,0,1,0-86.62,0A80.013,80.013,0,0,0,248,223.6V248H112V199.48a64,64,0,1,0-16,0v13.21L85.66,202.34a8,8,0,0,0-11.32,11.32L96,235.31V248H16a8,8,0,0,0-8,8A248,248,0,0,0,431.36,431.36,246.381,246.381,0,0,0,504,256,8,8,0,0,0,496,248ZM360,136a48,48,0,1,1,56,47.32V160a8,8,0,0,0-16,0v23.32A48.069,48.069,0,0,1,360,136Zm-168,8a63.694,63.694,0,0,1,35.32-57.22,8,8,0,0,0,2.86-11.88,32,32,0,1,1,51.64,0,8,8,0,0,0,2.86,11.88A63.992,63.992,0,0,1,264,207.48V179.31l29.66-29.65a8,8,0,1,0-11.32-11.32L264,156.69V120a8,8,0,0,0-16,0v87.48A64.073,64.073,0,0,1,192,144ZM56,136a48,48,0,1,1,56,47.32V160a8,8,0,0,0-16,0v23.32A48.069,48.069,0,0,1,56,136ZM24.13,264H197.78l-3.6,9.01-72.5,14.5-21.24-14.17a8.013,8.013,0,0,0-8.88,0l-24,16a9.11,9.11,0,0,0-.92.72L33.03,320.41A231.936,231.936,0,0,1,24.13,264ZM208,447.56l-3.79,34.67A230.526,230.526,0,0,1,91.95,420.05c-.29-.29-.57-.59-.85-.88l46.2-41.58,25.22,12.62,14.82,22.23a8.037,8.037,0,0,0,4.72,3.32L208,422.25Zm212.05-27.51A230.48,230.48,0,0,1,256,488a235.121,235.121,0,0,1-36.02-2.78l3.97-36.35A8.457,8.457,0,0,0,224,448V416a8,8,0,0,0-6.06-7.76l-29-7.25-14.28-21.43a8.152,8.152,0,0,0-3.08-2.72l-32-16a8,8,0,0,0-8.93,1.21L80.23,407.43a230.527,230.527,0,0,1-41.74-70.4l38.44-34.7L96,289.61l19.56,13.05a8.023,8.023,0,0,0,6.01,1.18l80-16a8.009,8.009,0,0,0,5.86-4.87L215.02,264H375.48l11.98,6.63,47.42,39.52a7.964,7.964,0,0,0,4.63,1.83l41.08,2.52A230.621,230.621,0,0,1,420.05,420.05Zm64.04-121.36-40.98-2.51L404.5,264h83.37A234.785,234.785,0,0,1,484.09,298.69Z"/><path d="M364.437,369.344,344,355.719V312a8,8,0,0,0-9.131-7.919l-56,8A7.992,7.992,0,0,0,273.6,315.2l-24,32a8,8,0,0,0-1.361,6.74l8,32a8,8,0,0,0,4.79,5.488l38.475,15.39,14.839,14.839a8,8,0,0,0,10.094,1l24-16a8.01,8.01,0,0,0,2.219-2.218l16-24A8,8,0,0,0,364.437,369.344Zm-26.206,24.887L321.02,405.706l-11.363-11.363a8.01,8.01,0,0,0-2.686-1.771l-36.2-14.481-6.084-24.337,19.727-26.3L328,321.224V360a8,8,0,0,0,3.562,6.656l17.344,11.563Z"/></g></svg>' },
    { titulo: 'CO2 evitado', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m352 80h-16v-48a24 24 0 0 0 -48 0v48h-64v-48a24 24 0 0 0 -48 0v48h-16a8 8 0 0 0 -8 8v152a48.051 48.051 0 0 0 48 48h16v24a8 8 0 0 0 8 8h8v176a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-176h8a8 8 0 0 0 8-8v-24h16a48.051 48.051 0 0 0 48-48v-152a8 8 0 0 0 -8-8zm-48-48a8 8 0 0 1 16 0v48h-16zm-112 0a8 8 0 0 1 16 0v48h-16zm72 456h-16v-168h16zm16-184h-48v-16h48zm64-64a32.036 32.036 0 0 1 -32 32h-112a32.036 32.036 0 0 1 -32-32v-112h176zm0-128h-176v-16h176z"/><path d="m271 184h-19.071l11.471-27.963a8 8 0 0 0 -14.8-6.074l-16 39a8 8 0 0 0 7.4 11.037h19.456l-10.946 29.191a8 8 0 1 0 14.98 5.618l15-40a8 8 0 0 0 -7.49-10.809z"/></g></svg>' },
    { titulo: 'Recaudo', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m352 80h-16v-48a24 24 0 0 0 -48 0v48h-64v-48a24 24 0 0 0 -48 0v48h-16a8 8 0 0 0 -8 8v152a48.051 48.051 0 0 0 48 48h16v24a8 8 0 0 0 8 8h8v176a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-176h8a8 8 0 0 0 8-8v-24h16a48.051 48.051 0 0 0 48-48v-152a8 8 0 0 0 -8-8zm-48-48a8 8 0 0 1 16 0v48h-16zm-112 0a8 8 0 0 1 16 0v48h-16zm72 456h-16v-168h16zm16-184h-48v-16h48zm64-64a32.036 32.036 0 0 1 -32 32h-112a32.036 32.036 0 0 1 -32-32v-112h176zm0-128h-176v-16h176z"/><path d="m271 184h-19.071l11.471-27.963a8 8 0 0 0 -14.8-6.074l-16 39a8 8 0 0 0 7.4 11.037h19.456l-10.946 29.191a8 8 0 1 0 14.98 5.618l15-40a8 8 0 0 0 -7.49-10.809z"/></g></svg>' },
  ];
  systemCard = [
    { titulo: 'SISTEMAS OPERANDO', imagen: '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><g><path d="M300,248H276.938l7.013-63.116a8,8,0,0,0-13.93-6.2l-64,72A8,8,0,0,0,212,264h23.062l-7.013,63.116a8,8,0,0,0,13.93,6.2l64-72A8,8,0,0,0,300,248Zm-53.271,55.889,5.222-47A8,8,0,0,0,244,248H229.814l35.457-39.889-5.222,47.005A8,8,0,0,0,268,264h14.186Z"/><path d="M495.77,207.5l-46.09-1.53a198.408,198.408,0,0,0-21.97-52.57L459,119.67a8,8,0,0,0-.21-11.1L402.23,52a8.018,8.018,0,0,0-11.13-.19L357.24,83.49a198.513,198.513,0,0,0-51.7-21.29L304,15.73A8.01,8.01,0,0,0,296,8H216a8,8,0,0,0-7.99,7.7l-1.75,46.55a198.306,198.306,0,0,0-52.12,21.6L119.9,51.81a8.018,8.018,0,0,0-11.13.19L52.21,108.57a8,8,0,0,0-.21,11.1l31.9,34.39a198.324,198.324,0,0,0-21.58,51.9L16.23,207.5a8.01,8.01,0,0,0-7.73,8v80a8,8,0,0,0,7.7,7.99l45.92,1.73a198.319,198.319,0,0,0,21.36,52L51.31,391.6a8.018,8.018,0,0,0,.19,11.13l56.57,56.56a8,8,0,0,0,11.1.21l34.25-31.78a198.18,198.18,0,0,0,52.84,22.03l1.75,46.55A8,8,0,0,0,216,504h80a8.01,8.01,0,0,0,8-7.73l1.54-46.47a198.2,198.2,0,0,0,52.43-21.72l33.86,31.42a8,8,0,0,0,11.1-.21l56.57-56.56a8.018,8.018,0,0,0,.19-11.13l-31.55-33.72a198.258,198.258,0,0,0,21.74-52.66l45.92-1.73a8,8,0,0,0,7.7-7.99v-80A8.01,8.01,0,0,0,495.77,207.5Zm-8.27,80.29-44.3,1.67a7.981,7.981,0,0,0-7.51,6.27,182.531,182.531,0,0,1-24.31,58.86,8,8,0,0,0,.9,9.76l30.44,32.53-45.65,45.65-32.68-30.31a7.986,7.986,0,0,0-9.73-.88,182.386,182.386,0,0,1-58.64,24.28,8.006,8.006,0,0,0-6.26,7.55L288.26,488H223.71l-1.69-44.91a7.983,7.983,0,0,0-6.25-7.51,182.553,182.553,0,0,1-59-24.6,7.987,7.987,0,0,0-9.76.87l-33.08,30.68L68.28,396.88l31.04-33.17a8,8,0,0,0,.92-9.73,182.731,182.731,0,0,1-23.93-58.24,8,8,0,0,0-7.51-6.28L24.5,287.8V223.24l44.44-1.49a8.005,8.005,0,0,0,7.54-6.24,182.355,182.355,0,0,1,24.17-58.14,8.016,8.016,0,0,0-.88-9.74l-30.8-33.2,45.65-45.65L147.67,99.7a7.99,7.99,0,0,0,9.76.91,182.59,182.59,0,0,1,58.34-24.19,7.983,7.983,0,0,0,6.25-7.51L223.71,24h64.55l1.5,44.83a8.006,8.006,0,0,0,6.26,7.55A182.547,182.547,0,0,1,354,100.25a8,8,0,0,0,9.73-.92l32.65-30.55,45.65,45.65-30.2,32.56a8,8,0,0,0-.87,9.76,182.5,182.5,0,0,1,24.56,58.76,8.014,8.014,0,0,0,7.54,6.25l44.44,1.48Z"/><path d="M256,136A120,120,0,1,0,376,256,120.136,120.136,0,0,0,256,136Zm0,224A104,104,0,1,1,360,256,104.118,104.118,0,0,1,256,360Z"/><path d="M256,104c-83.813,0-152,68.187-152,152s68.187,152,152,152,152-68.187,152-152S339.813,104,256,104Zm0,288c-74.99,0-136-61.01-136-136s61.01-136,136-136,136,61.01,136,136S330.99,392,256,392Z"/></g></svg>' },
    { titulo: 'SISTEMAS FALLANDO', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m256 216a88 88 0 1 0 -88-88 88.1 88.1 0 0 0 88 88zm0-160a72 72 0 1 1 -72 72 72.081 72.081 0 0 1 72-72z"/><path d="m256 32a8 8 0 0 0 8-8v-8a8 8 0 0 0 -16 0v8a8 8 0 0 0 8 8z"/><path d="m248 232v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -16 0z"/><path d="m360 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m144 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m329.539 62.461a7.976 7.976 0 0 0 5.657-2.343l5.657-5.657a8 8 0 1 0 -11.314-11.314l-5.657 5.653a8 8 0 0 0 5.657 13.657z"/><path d="m176.8 195.883-5.657 5.657a8 8 0 0 0 11.314 11.313l5.657-5.658a8 8 0 1 0 -11.314-11.312z"/><path d="m323.882 195.882a8 8 0 0 0 0 11.313l5.657 5.658a8 8 0 1 0 11.314-11.313l-5.657-5.657a8 8 0 0 0 -11.314-.001z"/><path d="m176.8 60.118a8 8 0 1 0 11.318-11.318l-5.657-5.657a8 8 0 0 0 -11.314 11.314z"/><path d="m496 464h-96v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-192v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-96a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-160-48h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm-240 80h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm320-24h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm-208-120h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm344 56h-464v-8h464z"/></g></svg>' },
    { titulo: 'SISTEMAS EN REVISIÓN', imagen: '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><g><path d="M40,368a32,32,0,1,0,32,32A32.036,32.036,0,0,0,40,368Zm0,48a16,16,0,1,1,16-16A16.019,16.019,0,0,1,40,416Z"/><path d="M328,400a32,32,0,1,0,32,32A32.036,32.036,0,0,0,328,400Zm0,48a16,16,0,1,1,16-16A16.019,16.019,0,0,1,328,448Z"/><path d="M431.66,80.94A246.366,246.366,0,0,0,256.92,8h-.9C190.72,8,128.96,33.72,82.03,80.49A251.467,251.467,0,0,0,27.9,160.37,247.427,247.427,0,0,0,8,257.86V328a32.172,32.172,0,0,0,31.41,32,31.537,31.537,0,0,0,22.75-9.17A32.984,32.984,0,0,0,72,327.46V312a16,16,0,0,1,16.31-16c8.65.17,15.69,7.59,15.69,16.55V408a32.172,32.172,0,0,0,31.41,32,31.391,31.391,0,0,0,22.75-9.17A32.984,32.984,0,0,0,168,407.46V387.71a31.982,31.982,0,0,0,32,0V472a32.155,32.155,0,0,0,31.4,31.99c.2.01.39.01.59.01a31.5,31.5,0,0,0,22.17-9.16A33.007,33.007,0,0,0,264,471.46V328a16,16,0,0,1,32,0v32a32.155,32.155,0,0,0,31.4,31.99,31.419,31.419,0,0,0,22.76-9.15A33.007,33.007,0,0,0,360,359.46V280a16,16,0,0,1,32,0V392a32.172,32.172,0,0,0,31.41,32,31.423,31.423,0,0,0,22.75-9.17A32.984,32.984,0,0,0,456,391.46v-59.8a31.462,31.462,0,0,0,38.16-4.83A32.984,32.984,0,0,0,504,303.46V256A246.415,246.415,0,0,0,431.66,80.94ZM160,232a8,8,0,0,0-8,8V407.46a16.868,16.868,0,0,1-5.05,11.95A15.6,15.6,0,0,1,135.7,424,16.079,16.079,0,0,1,120,408V312.55c0-17.62-14.08-32.22-31.38-32.54A31.638,31.638,0,0,0,72,284.28V272a8,8,0,0,0-16,0v55.46a16.868,16.868,0,0,1-5.05,11.95A15.551,15.551,0,0,1,39.7,344,16.079,16.079,0,0,1,24,328V257.86a231.553,231.553,0,0,1,18.62-91.22,235.727,235.727,0,0,1,50.7-74.82c2.2-2.2,4.45-4.33,6.72-6.42l29.56,39.4a7.982,7.982,0,0,0,4.83,3.04l36.43,7.29,29.44,51.51,7.48,52.37-13.6,34L168,278.24V240A8,8,0,0,0,160,232Zm184,48v79.46a16.873,16.873,0,0,1-5.05,11.96A15.655,15.655,0,0,1,327.7,376,16.079,16.079,0,0,1,312,360V328a32,32,0,0,0-64,0V471.46a16.873,16.873,0,0,1-5.05,11.96A15.746,15.746,0,0,1,231.7,488,16.079,16.079,0,0,1,216,472V312a8,8,0,0,0-16,0v48a16,16,0,0,1-32,0V294.56l33.57-6.72a8.009,8.009,0,0,0,5.86-4.87l16-40a7.969,7.969,0,0,0,.49-4.1l-8-56a7.983,7.983,0,0,0-.97-2.84l-32-56a7.984,7.984,0,0,0-5.38-3.87l-37-7.41L112.19,74.92A228.28,228.28,0,0,1,256.02,24h.84a234.189,234.189,0,0,1,36.44,2.98L251.29,57.53A8,8,0,0,0,248,64v64a7.986,7.986,0,0,0,2.02,5.31l64,72a8.007,8.007,0,0,0,9.56,1.85l8.84-4.43,10.35,20.7-13.43,20.13a8,8,0,0,0,3.51,11.79l16.44,7.05A31.8,31.8,0,0,0,344,280Zm144,23.46a16.868,16.868,0,0,1-5.05,11.95A15.559,15.559,0,0,1,471.7,320,16.079,16.079,0,0,1,456,304V240a8,8,0,0,0-16,0V391.46a16.868,16.868,0,0,1-5.05,11.95A15.543,15.543,0,0,1,423.7,408,16.079,16.079,0,0,1,408,392V280a31.979,31.979,0,0,0-45.11-29.18l-14.9-6.38,10.67-16a8.024,8.024,0,0,0,.5-8.02l-16-32a8.017,8.017,0,0,0-10.74-3.58l-10.51,5.26L264,124.96V68.07l50.44-36.68A232.245,232.245,0,0,1,488,256Z"/></g></svg>' },
  ];
  proyects = [];
  constructor(private global: GlobalService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private route: Router) {

  }

  ngOnInit(): void {
    this.spinner.show();
    this.clientClass = this.global.CLIENTDATALIWA[8];
    window.scroll(0, 0);
    this.Style = this.global.mapStyle;
      const pdata10 = { option: 'aulas' , client : this.global.Id_Client};
      this.global.consultar(pdata10, async (err10, response10) => {
        this.beneficiarys = await response10;
        this.setDiagram = true;
        this.spinner.hide();
      });

  }

  clickedMarker(infowindow) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }

  // setCharts() {
  //   const labels = [
  //     'Lunes',
  //     'Martes',
  //     'Miércoles',
  //     'Jueves',
  //     'Viernes',
  //     'Sábado',
  //     'Domingo',
  //   ];
  //   const labels1 = [
  //     'Enero',
  //     'Febrero',
  //     'Marzo',
  //     'Abril',
  //     'Mayo',
  //     'Junio',
  //     'Julio',
  //   ];
  //   const data1 = {
  //     labels: labels1,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [0, 40, 75, 37, 47, 31, 30, 27],
  //     }]
  //   };
  //   const data2 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [32, 20, 25, 12, 20, 30, 45],
  //     }]
  //   };
  //   const data3 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [10, 10, 15, 31, 20, 30, 15],
  //     }]
  //   };
  //   const data4 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [89, 25, 15, 21, 90, 30, 50],
  //     }]
  //   };
  //   const data5 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [10, 10, 52, 22, 20, 33, 45],
  //     }]
  //   };
  //   const data6 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [10, 80, 52, 72, 80, 90, 145],
  //     }]
  //   };
  //   const data7 = {
  //     labels: labels,
  //     datasets: [{
  //       label: '',
  //       backgroundColor: 'rgb(230, 230, 230)',
  //       borderColor: 'rgb(3, 40, 67)',
  //       data: [10, 10, 15, 21, 20, 30, 45],
  //     }]
  //   };
  //   let chrt1 = new Chart(document.getElementById('firstChart'), {
  //     type: 'line',
  //     data: data1,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt2 = new Chart(document.getElementById('scndChart'), {
  //     type: 'line',
  //     data: data2,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt3 = new Chart(document.getElementById('thirdChart'), {
  //     type: 'line',
  //     data: data3,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt4 = new Chart(document.getElementById('fourthChart'), {
  //     type: 'line',
  //     data: data4,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt5 = new Chart(document.getElementById('fifthChart'), {
  //     type: 'line',
  //     data: data5,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt6 = new Chart(document.getElementById('sixthChart'), {
  //     type: 'line',
  //     data: data6,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  //   let chrt7 = new Chart(document.getElementById('seventhChart'), {
  //     type: 'line',
  //     data: data7,
  //     options: {
  //       elements: {
  //         point: {
  //           radius: 0
  //         }
  //       },
  //       legend: {
  //         display: false
  //       },
  //       animation: {
  //         duration: 0 // general animation time
  //       },
  //       hover: {
  //         animationDuration: 0 // duration of animations when hovering an item
  //       },
  //       responsiveAnimationDuration: 0, // animation duration after a resize
  //       maintainAspectRatio: false,
  //       responsive: true,
  //       scales: {
  //         xAxes: [{
  //           display: false
  //         }],
  //         yAxes: [{
  //           display: false
  //         }]
  //       }
  //     }
  //   })
  // }
  sanitize(data: any) {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(data);
    return this.safeHtml;
  }

}
